import mqqapi from './mqqapi';

export default function (callback, resCallback = function () { }) {
  mqqapi().then(() => {
    mqq.ui.setOnShareHandler(function (type) {
      var data = callback(type)
      if (mqq.compare("5.4") != 0) {//5.4不能增加公众号显示，会导致程序crash
        data.puin = '3042703080';
        data.sourceName = '腾讯充值';
      }
      mqq.ui.shareMessage(data, function (res) {
        resCallback(res);
      });
    });
  })
}
